import { dayjs } from '@mobi/utils/date'
import { meetingIdToContestType } from '@core/Areas/Racing/helpers'
import type { IconType } from '@mobi/component-library/Legacy/Icon/Icon'
import type { BlackbookEntryRacingToday, BlackbookEntry } from '@core/Areas/Blackbook/types'

export function isBettingAvailable(
  RacingTodayDetails: BlackbookEntryRacingToday['RacingTodayDetails']
): boolean {
  return !!(
    !RacingTodayDetails.AbandonedInd &&
    !RacingTodayDetails.CloseTime &&
    !RacingTodayDetails.ResultedInd &&
    !RacingTodayDetails.ScratchedInd &&
    !RacingTodayDetails.SuspendedInd
  )
}

const iconDict: IconDict = { Dogs: 'dog', Races: 'races', Trots: 'trot', Jockeys: 'jockey' }

export function getIconName(code: BlackbookEntry['Code'], meetingId?: string): IconType {
  if (meetingId) {
    const meetingToIconKey = meetingIdToContestType(meetingId)
    if (meetingToIconKey) return meetingToIconKey
  }
  return iconDict[code] || 'tab'
}

export const showPushAlertPrompt = (lastPrompt: number | undefined, timesShown: number) => {
  if (!lastPrompt) return true

  const nextPrompt =
    timesShown > 3
      ? dayjs(lastPrompt).add(6, 'month')
      : dayjs(lastPrompt).add(7 * timesShown, 'day')

  return dayjs().isAfter(nextPrompt)
}

// Types
type IconDict = Record<BlackbookEntry['Code'], IconType>
